import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__managers_return_bonus',
    path: '/managers/return-bonus',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/managers/return-bonus.vue' /* webpackChunkName: "pages-car-managers-return-bonus.vue" */
        )
      )
  }
]
